import React,{useState} from 'react'
import StageProgressBar from "../../components/stage_progress_bar";
import Tabbar from "../../components/tabbar";
import ProposalTab from "./stages/proposal";
import VotingTab from "./stages/voting";
import TestnetTab from "./stages/testnet";
import {connect} from "react-redux";
import MainnetTab from "./stages/mainnet";

const stages = [
    'Proposal',
    'Odds Modeling',
    'Simulation',
    'Voting',
    'Testnet',
    'Mainnet',

];

const getTab = (stage)=> {
    switch(stage){
        case 'Proposal':
            return <ProposalTab/>
        case 'Voting':
            return <VotingTab/>
        case 'Testnet':
            return <TestnetTab/>
        case 'Mainnet':
            return <MainnetTab/>
        default:
            return <div><h3>{stage}</h3></div>
    }
}

const ProjectDetailPage = ({
    stage,
    ...props
}) => {

    let [selectedStage,setStage] = useState('Proposal')

    return(
        <div className={'container'}>
            <br/>
            <br/>
            <StageProgressBar
            stages={stages}
            activeStage={stages[stage]}
            />

            <Tabbar
            items={stages}
            disabledItems={stages.slice(stage+2,stages.length)}
            activeItem={selectedStage}
            onSelect={(val)=>{
                console.log('selected')
                setStage(val)
            }}
            />
            <br/>
            <div className={'container-md'}>
            {
                getTab(selectedStage)
            }
            </div>

        </div>
    )
}

const mapStateToProps = (store) => ({
    stage: store.appReducer.stage

})


export default connect(mapStateToProps)(ProjectDetailPage)